(function () {
  function initCustomerReviewHero() {
    var endLinks = document.querySelectorAll('[data-cr-scroll-end]');
    var links = document.querySelectorAll('[data-cr-scroll]');

    endLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));

        if (!target) {
          return;
        }

        event.preventDefault();

        var targetBottom = target.getBoundingClientRect().bottom + window.pageYOffset;

        window.scrollTo({
          top: targetBottom,
          behavior: 'smooth'
        });
      });
    });

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));

        if (!target) {
          return;
        }

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomerReviewHero);
  } else {
    initCustomerReviewHero();
  }
})();
